import {apiMe} from '@http/common'
import {identification} from "@http/user_center/userInfo";
import {getLawyerStatus} from '@/http/modules/lawcase'

const state = {
    userinfo: {},
    baseInfo: {},
    lawyerInfo: {},
    authentication: {},
    isClean: false,

}
const mutations = {
    setuserinfo(state, userinfo) {
        state.userinfo = userinfo
    },
    setBaseinfo(state, baseInfo) {
        state.baseInfo = baseInfo
    },
    setLawyerInfo(state, isClean = false) {
        state.isClean = isClean
    },
}
const actions = {
    serUserInfo({commit}) {
        return new Promise((resolve, reject) => {
            apiMe()
                .then(res => {
                    if (res) {
                        commit('setuserinfo', res.data)
                        commit('setBaseinfo', res.data)
                    }
                })
                .catch(err => reject(err));
        });
    },
    setLawyerInfo({commit}, isClean = false) {
        return new Promise((resolve, reject) => {
            // console.log('aaaaaaaaaaaaaaa');
            // let lawyerInfo, authentication
            // identification({hiddenApproval: true}).then((res) => {
            //     authentication = res.authenticationStatus;
            // }).catch((err) => {
            //     console.log(err);
            // });
            // getLawyerStatus().then(res => {
            //     lawyerInfo = res.status;
            // }).catch(err => {
            //     console.log(err)
            // })
            commit('setLawyerInfo', isClean)
        });
    },

}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
